<template>
  <div>
    <div class="is-flex is-justify-center" style="margin-bottom: 1rem;">
      <hr class="has-text-dark" style="width: 5%" />
      <h1 class="title is-size-4" style="margin: auto">
        Distribución de encuestados por niveles de calidad de clima
      </h1>
      <hr class="has-text-dark" style="width: 5%" />
    </div>
    <div style="margin-top: 15px;">
      <div v-for="(v, k) in detailData" :key="k">
        <GraphDetailResult
          :group="null"
          :var="k"
          :title="k === 'CClimad' ? nameResults() : namevars[k]"
          :change="change"
          :data="summary.total[k]"
          :dataTarget="
            summary.processComp ? summary.processComp.total[k] : null
          "
          :items="false"
          :ranges="rangos"
          :target-year="comparisonYear"
          @switchSubGroups="$emit('switch-sub-groups', $event)"
        />
        <div v-for="(v1, k1) in v" :key="k1">
          <GraphDetailResult
            :group="null"
            :var="k1"
            :title="namevars[k1]"
            :change="change"
            :data="summary.total[k1]"
            :dataTarget="
              summary.processComp ? summary.processComp.total[k1] : null
            "
            :items="true"
            :active="v1.active"
            :ranges="rangos"
            :target-year="comparisonYear"
            @switchSubGroups="$emit('switch-sub-groups', $event)"
            @openMenuInter="$emit('open-menu-inter', $event)"
          />
          <!-- Whit Switch -->
          <article v-if="v1 && v1.active && !v1.unique" class="message">
            <div class="message-body">
              <div v-for="(v2, k2) in v1.data" :key="k2">
                <GraphDetailResult
                  :group="k1"
                  :var="v2"
                  :title="namevars[v2]"
                  :change="change"
                  :data="summary.total[v2]"
                  :dataTarget="
                    summary.processComp
                      ? summary.processComp.total[v2]
                      : null
                  "
                  :items="false"
                  :ranges="rangos"
                  :target-year="comparisonYear"
                  @switchSubGroups="$emit('switch-sub-groups', $event)"
                  @openMenuInter="$emit('open-menu-inter', $event)"
                />
              </div>
            </div>
          </article>
          <!-- Not Switch -->
          <div v-if="v1 && v1.data && v1.unique">
            <div v-for="(v2, k2) in v1.data" :key="k2">
              <GraphDetailResult
                :group="v1.group || k1"
                :var="v2"
                :title="namevars[v2]"
                :change="change"
                :data="summary.total[v2]"
                :dataTarget="
                  summary.processComp
                    ? summary.processComp.total[v2]
                    : null
                "
                :active="false"
                :ranges="rangos"
                :target-year="comparisonYear"
                @switchSubGroups="$emit('switch-sub-groups', $event)"
                @openMenuInter="$emit('open-menu-inter', $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphDetailResult from "../graphDetailResult.vue";

export default {
  name: "Distribution",
  components: {
    GraphDetailResult,
  },
  props: {
    summary: {
      type: Object,
      required: true,
    },
    namevars: {
      type: Object,
      required: true,
    },
    change: {
      type: Number,
      required: true,
    },
    rangos: {
      type: Function,
      required: true,
    },
    nameResults: {
      type: Function,
      required: true,
    },
    detailData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    comparisonYear() {
      const fecha =
        this.summary.processComp && this.summary.processComp.fecha;
      return fecha ? new Date(fecha).getFullYear() : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .title.is-size-4 {
    font-size: 1rem !important;
    margin-right: 8px !important;
    margin-left: 8px !important;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/tabs/Distribution.vue